import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Icon from './Icon';
class CommitStatusIcon extends Component {
    render() {
        const { isCommitDone, className, isDashboard, commitOptions, isCommitTimedOut, isCommitMeetingThreshold, t } = this.props;
        const commitHasThreshold = !!commitOptions?.thresholds;
        const isCommitSucceeded = isCommitDone && isCommitMeetingThreshold;
        const thresholdResult = commitHasThreshold && isCommitMeetingThreshold;
        const iconText = isCommitSucceeded ? 'successful' : 'failed';
        const iconTextThresholds = thresholdResult ? 'passed' : 'crossed';
        const result = commitHasThreshold ? thresholdResult && isCommitSucceeded : isCommitSucceeded;
        const resultMessage = `${t(isDashboard ? 'latestCommit' : 'commit')} ${t('endedUpAs')} ${t(result ? 'successful' : 'failed')}. ${t('commit')} ${commitHasThreshold && `${t(iconTextThresholds)} repository thresholds and`} ${t('analyzeFinished')} ${t(iconText)}.`;
        const message = isCommitTimedOut ? `${t('latestCommit')} ${t('failed')}` : resultMessage;
        const iconName = isCommitTimedOut ? 'exclamation' : result ? 'check' : 'times';
        const iconColor = !result || isCommitTimedOut ? 'danger' : 'success';
        return _jsx(Icon, { name: iconName, className: clsx(`text-${iconColor}`, className), title: message });
    }
}
CommitStatusIcon.defaultProps = {
    className: '',
    isDashboard: false,
};
export default withTranslation()(CommitStatusIcon);
